export const getCategoryBadgeColor = (category?: string | null): string => {
    if (!category) return 'bg-gray-100 text-gray-800';

    const normalized = category.trim().toLowerCase();

    if (normalized.includes('non-operating') || normalized.includes('internal transfer')) {
        return 'bg-[#D9F3FF] text-[#008CFF]';
    }
    if (normalized.includes('revenue') || normalized.includes('income') || normalized.includes('sales')) {
        return 'bg-emerald-100 text-emerald-800';
    }
    if (normalized.includes('cogs') || normalized.includes('cost of goods')) {
        return 'bg-amber-100 text-[#8C7720]';
    }
    if (normalized.includes('labor') || normalized.includes('payroll') || normalized.includes('salary')) {
        return 'bg-violet-100 text-violet-800';
    }
    if (normalized.includes('expense') || normalized.includes('opex') || normalized.includes('operating')) {
        return 'bg-blue-100 text-blue-800';
    }
    if (normalized.includes('draw') || normalized.includes('equity') || normalized.includes('distribution')) {
        return 'bg-indigo-100 text-indigo-800';
    }
    if (normalized.includes('asset') || normalized.includes('equipment')) {
        return 'bg-cyan-100 text-cyan-800';
    }
    if (normalized.includes('liability') || normalized.includes('loan')) {
        return 'bg-rose-100 text-rose-800';
    }

    const colors = [
        'bg-pink-100 text-pink-800',
        'bg-fuchsia-100 text-fuchsia-800',
        'bg-cyan-100 text-cyan-800',
        'bg-teal-100 text-teal-800',
        'bg-lime-100 text-lime-800',
        'bg-purple-100 text-purple-800',
    ];

    let hash = 0;
    for (let i = 0; i < normalized.length; i++) {
        hash = normalized.charCodeAt(i) + ((hash << 5) - hash);
    }

    return colors[Math.abs(hash) % colors.length];
};
